
import { COMPUTE_LINK_TARGET } from '@marketplace/mixins/helpers.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import Cookies from 'js-cookie'

export default {
    name: 'NotificationCookie',
    mixins: [COMPUTE_LINK_TARGET],
    props: {
        termsUrl: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            hasSeenWarning: parseInt(Cookies.get('COOKIEmessage')),
            hasBeenClosed: false,
        }
    },
    mounted() {
        EventBus.$on('destroyCookieMessage', this.destroy)
        setTimeout(() => {
            this.updateCookie(1)
        }, 500)
    },

    beforeDestroy() {
        EventBus.$off('destroyCookieMessage')
    },

    methods: {
        destroy() {
            this.hasBeenClosed = true
            this.updateCookie(1)
        },
        updateCookie(number) {
            Cookies.set('COOKIEmessage', number, { expires: 365 })
        },
    },
}
